/**
 * AppLogo Component
 *
 * Displays the application logo with branding information for the Internet Access Registration (IAR) system.
 * The component renders a dynamic logo that changes based on registration completion status.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.isRegistrationCompleted=false] - Indicates whether registration is complete.
 *                                                          When true, displays the unlock logo; when false, displays the lock logo.
 *
 * @returns {JSX.Element} A div container with the logo image and application branding text (IAR).
 *
 * @example
 * // Display locked state (default)
 * <AppLogo />
 *
 * @example
 * // Display unlocked state
 * <AppLogo isRegistrationCompleted={true} />
 */

import logo from '../assets/lock.svg'
import unlockLogo from '../assets/unlock.svg'
import styles from './scss/AppLogo.module.scss'

export default function AppLogo({ isRegistrationCompleted = false }) {
  return (
    <div className={styles.appLogoContainer}>
      <img src={isRegistrationCompleted ? unlockLogo : logo} alt='App Logo' />

      <div>
        <h2>IAR</h2>
        <span>Internet Access Registration</span>
      </div>
    </div>
  )
}
